import React from 'react';
import StyledHeading from './Heading.style';

const Heading = (props) => {
    const { children, level } = props,
    isHeading = (props.level === 'h1' || props.level === 'h2' || props.level === 'h3' || props.isHeading),
    newProps = {
        ...props,
        fontFamily: (isHeading) ? "Anton" : "Overpass",
        textTransform: (isHeading) ? 'uppercase' : '',
        letterSpacing: (isHeading) ? '-0.5px' : ''
    };
    return (
        <StyledHeading {...newProps} as={level}>
            {children}
        </StyledHeading>
    );
};

/**
 * Definition of default values for component props
 */
Heading.defaultProps = {
    children: undefined,
    level: 'h1',
    truncate: false,
    color: undefined,
    display: 'block',
    align: 'inherit',
    fontFamily: undefined,
    marginTop: '0',
    marginBottom: '1rem',
    fontWeight: 'normal'
};

export default Heading;